import axios from '../axios';
const missionEndpoint = 'mission';

const fetchMissions = (setmissions) => {
    axios.get(missionEndpoint+'/getMissions').then(
        (res) => {
            console.log(res.data);
            setmissions(res.data);
        },
        (err) => {
            console.error('error in getting MISSIONS', err);
        }
    );
};

const fetchTrackedMissions = (settrackedmissions) => {
    axios.get(missionEndpoint+'/getMissions', { params: { tracked: true } }).then(
        (res) => {
            console.log(res.data);
            settrackedmissions(res.data);
        },
        (err) => {
            console.error('error in getting tracked missions', err);
        }
    );
};

const fetchUntrackedMissions = (setuntrackedmissions) => {
    axios.get(missionEndpoint+'/getMissions', { params: { tracked: false } }).then(
        (res) => {
            console.log(res.data);
            setuntrackedmissions(res.data);
        },
        (err) => {
            console.error('error in getting untracked missions', err);
        }
    );
};

//fetches last 7 missions created
const fetchLastTrackedMissions = (setLastTrackedMissions, number) => {
    axios.get(missionEndpoint+'/getMissions', { params: { number: number } }).then(
        (res) => {
            console.log(res.data);
            if (number === 1) {
                setLastTrackedMissions(res.data[0]);
                console.log(res.data[0]);
            } else {
                setLastTrackedMissions(res.data);
            }
        },
        (err) => {
            console.error('error in getting last tracked missions', err);
        }
    );
};

const fetchProjectlessMissions = (setMissions) => {
    axios.get(missionEndpoint + '/getProjectlessMissions').then(
        (res) => {
            console.log(res.data);
            setMissions(res.data);
        },
        (err) => {
            console.error('error in getting projectlesss missions', err);
        }
    );
};

const trackMission = (mission) => {
    axios.put(missionEndpoint + '/' + `${mission._id}`, mission).then(
        (res) => {
            console.log(res.data);
        },
        (err) => {
            console.error(err);
        }
    );
};

export {
    fetchLastTrackedMissions,
    fetchMissions,
    fetchProjectlessMissions,
    fetchTrackedMissions,
    fetchUntrackedMissions,
    trackMission,
};
